import { Divider, Typography } from '@mui/material';

const CpdSectionHeader = ({ title }) => (
  <>
    <Divider sx={{ my: 3, mt: 4 }} />
    <Typography variant='h6' sx={{ mb: 3 }}>
      {title}
    </Typography>
  </>
);

export default CpdSectionHeader;
